export const MIN_PASSWORD_LENGTH = 10;
export const CONFIRM_CODE_LENGTH = 6;
export const PASSWORD_REGEX =
  /^(?=\S)(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[$^*.[\]{()}?\-"!@#%&/\\,><':;|_~`+=\s])[\s\S]{9,}\S$/;
